import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, Button,
} from 'reactstrap';
import { logOut, LOGOUT_ICON, staticConstants } from '../../utils';


function Logout(props) {
  const {
    isOpen, onClose, role,
  } = props;

  const [modal, setModal] = useState(isOpen);
  const isAdminLogout = role === staticConstants.ROLE.SYSTEM_ADMIN;
  const toggle = () => {
    setModal(!modal);
    onClose();
  };
  const hideModal = () => {
    toggle();
    props.onClose();
  };


  return (
    <Modal isOpen={modal} className={`modal-logout modal-dialog-centered ${isAdminLogout ? 'modal-logout-admin' : ''}`}>
      <ModalBody>
        {!isAdminLogout && (
          <img src={LOGOUT_ICON} alt="logout" />
        )}
        <p>
          Are you sure you want to sign out
          {' '}
          {isAdminLogout ? '?' : 'of BYGmusic?'}
          {' '}
        </p>
        <div className="button-wrapper">
          <Button
            color="secondary"
            size="xs"
            className="btn-small"
            onClick={hideModal}
          >
            {isAdminLogout ? 'Cancel' : 'Not now'}
          </Button>
          <Button
            color="primary"
            className="btn-small"
            onClick={logOut}
          >
            Sign out
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

Logout.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};

export default Logout;
